import { createContext, useContext } from 'react';

const TooltipContainerContext = createContext<HTMLElement | null>(null);
TooltipContainerContext.displayName = 'TooltipContainerContext';

export const useTooltipContainerContext = () => useContext(TooltipContainerContext);

export default TooltipContainerContext;
